import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/errorHandler'; // Importar tratamento de erros global
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
